.leaflet-draw-toolbar .leaflet-bar {
  display: none;
}

.leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-circle {
  display: none;
}

.leaflet-touch .leaflet-draw-toolbar .leaflet-draw-draw-polygon {
  display: none;
}

.leaflet-draw-toolbar .leaflet-bar .leaflet-draw-toolbar-top {
  display: none;
}

.leaflet-touch .leaflet-draw-toolbar .leaflet-draw-edit-edit {
  display: none;
}

.leaflet-draw-actions a {
  background-color: rgba(255, 255, 255, 1);
  color: rgba(57, 57, 57, 1);
  margin-right: 8px;
}

.leaflet-draw-toolbar-top{
  border: none !important;
}
